// Render-tree rules for the `senjaTestimonials` blok, kept free of widget
// config so the catch-all page and the Storyblok registry can use them without
// shipping SENJA_WIDGET_GROUPS to every CMS page.

export const SENJA_BLOK_COMPONENT = "senjaTestimonials"

// Containers that render arbitrary nested bloks through StoryblokComponent,
// keyed by the field holding them. Other bloks (e.g. Section) render a fixed
// set of children, so a testimonial blok nested there never renders.
const RENDERED_CHILD_FIELDS: Record<string, string> = {
  container: "blocks",
}

function childBloks(record: Record<string, unknown>, field: string): unknown[] {
  const children = record[field]

  return Array.isArray(children) ? children : []
}

/** Testimonial bloks that actually render: the story body and generic containers. */
export function renderedSenjaBloks(
  content: unknown,
): Record<string, unknown>[] {
  const found: Record<string, unknown>[] = []

  const visit = (node: unknown): void => {
    if (typeof node !== "object" || node === null) {
      return
    }

    const record = node as Record<string, unknown>
    const component = String(record.component)

    if (component === SENJA_BLOK_COMPONENT) {
      found.push(record)

      return
    }

    const field = Object.hasOwn(RENDERED_CHILD_FIELDS, component)
      ? RENDERED_CHILD_FIELDS[component]
      : undefined

    if (field) {
      childBloks(record, field).forEach(visit)
    }
  }

  if (typeof content === "object" && content !== null) {
    childBloks(content as Record<string, unknown>, "body").forEach(visit)
  }

  return found
}

/** Whether a rendered blok replaces the path fallback (valid group or not). */
export function hasSenjaBlok(content: unknown): boolean {
  return renderedSenjaBloks(content).length > 0
}
